(function () {
    angular.module('components.loader', [
        'ngAnimate'
    ])
        .component('loader', {
            bindings: {
                onContentReady: '&?',
                onError: '&?'
            },
            template: '<div ng-class="{loaded: $ctrl.ready, initialized: $ctrl.initialized}"><div class="loading-indicator"><span class="fa fa-spin fa-spinner"></span></div><div class="content"></div></div>',
            transclude: {
                indicator: '?indicator',
                content: '?content'
            },
            controller: loaderController
        });

    loaderController.$inject = ['$element', '$attrs', '$q', '$transclude', '$timeout'];
    function loaderController($element, $attrs, $q, $transclude, $timeout) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.ready = false;

            if (!$transclude.isSlotFilled('content')) {
                $transclude(function (clone) {
                    if (clone.length)
                        $element.find('.content').html(clone);
                });
            }
            else {
                $transclude(function (clone) {
                    if (clone.length)
                        $element.find('.loading-indicator').html(clone);
                }, null, 'indicator');
                $transclude(function (clone) {
                    if (clone.length)
                        $element.find('.content').html(clone);
                }, null, 'content');
            }
        }
        ctrl.$postLink = function () {
            ctrl.initialized = true;
            var deferred = $q.defer();
            if (ctrl.onContentReady !== undefined) {
                ctrl.onContentReady({deferred: deferred})
            }
            else {
                var count = 0;
                var images = $element.find('.content img').filter(function() {
                    return !$(this).prop('complete');
                }).on('load.loader', function () {
                    count++;
                    if (count === images.length)
                        deferred.resolve();
                }).on('error.loader', function (error) {
                    images.off('load.loader');
                    deferred.reject(error);
                });
                if (!images.length)
                    deferred.resolve();
            }
            deferred.promise.then(function () {
                ctrl.ready = true;
            }).catch(function (error) {
                if (ctrl.onError !== undefined)
                    ctrl.onError({ error: error });
                ctrl.ready = true;
            });
        }
    }
})();